import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@onefootprint/ui';
import type { NavigationHeaderRightButtonProps } from '../../types';
const NavigationIconButton = t0 => {
  const $ = _c(5);
  const {
    icon: Icon,
    onClick,
    color,
    label: t1
  } = t0;
  const label = t1 === undefined ? "" : t1;
  const t2 = color ?? "primary";
  let t3;
  if ($[0] !== Icon || $[1] !== label || $[2] !== onClick || $[3] !== t2) {
    t3 = <IconButton onClick={onClick} aria-label={label} icon={Icon} color={t2} />;
    $[0] = Icon;
    $[1] = label;
    $[2] = onClick;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default NavigationIconButton;